(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cnqr-cart"]) return;
  try {
    
  (function () {
    // ── Qty / remove via AJAX ──
    document.querySelectorAll('[data-cnqr-qty-change]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.key;
        var qty = parseInt(b.dataset.qty, 10);
        if (isNaN(qty) || qty < 0) return;
        b.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { b.disabled = false; });
      });
    });

    // ── Terms: warn but don't block checkout ──
    var terms = document.getElementById('cart-terms');
    var form  = document.getElementById('cnqr-checkout-form');
    if (form && terms) {
      form.addEventListener('submit', function (e) {
        if (!terms.checked) {
          e.preventDefault();
          var box = terms.closest('.cnqr-cart__terms');
          box.style.outline = '2px solid #d84602';
          box.style.outlineOffset = '4px';
          terms.focus();
          setTimeout(function () {
            box.style.outline = '';
            box.style.outlineOffset = '';
          }, 1400);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cnqr-header"]) return;
  try {
    
  (function () {
    var header  = document.querySelector('[data-cnqr-header]');
    var drawer  = document.querySelector('[data-cnqr-drawer]');
    var search  = document.querySelector('[data-cnqr-search]');
    var overlay = document.querySelector('[data-cnqr-overlay]');

    function openDrawer() {
      if (drawer)  drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function openSearch() {
      if (search)  search.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var input = document.querySelector('[data-cnqr-search-input]');
        if (input) input.focus();
      }, 200);
    }
    function closeAll() {
      if (drawer)  drawer.classList.remove('is-open');
      if (search)  search.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-cnqr-menu-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    document.querySelectorAll('[data-cnqr-menu-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    document.querySelectorAll('[data-cnqr-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
    document.querySelectorAll('[data-cnqr-search-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // Smart sticky header — hides on scroll down, shows on scroll up
    if (header) {
      var lastScrollY = window.scrollY;
      var ticking = false;
      var SCROLL_THRESHOLD = 15;   // min px before hiding/showing
      var TOP_ZONE = 15;           // always visible in this zone

      var handleScroll = function () {
        var currentY = window.scrollY;
        var delta = currentY - lastScrollY;

        // data-scrolled for hero-page transparent→solid transition
        if (currentY > 80) {
          header.setAttribute('data-scrolled', 'true');
        } else {
          header.removeAttribute('data-scrolled');
        }

        // Always show header when near the very top
        if (currentY <= TOP_ZONE) {
          header.classList.remove('cnqr-h--hidden');
          lastScrollY = currentY;
          ticking = false;
          return;
        }

        // Hide on scroll down, show on scroll up (with threshold)
        if (delta > SCROLL_THRESHOLD) {
          header.classList.add('cnqr-h--hidden');
          lastScrollY = currentY;
        } else if (delta < -SCROLL_THRESHOLD) {
          header.classList.remove('cnqr-h--hidden');
          lastScrollY = currentY;
        }

        ticking = false;
      };

      var onScroll = function () {
        if (!ticking) {
          window.requestAnimationFrame(handleScroll);
          ticking = true;
        }
      };

      handleScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Cart count refresh from /cart.js
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.setAttribute('data-count', c.item_count);
      });
    }).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cnqr-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cnqr-slider]').forEach(function(slider) {
    var key = slider.getAttribute('data-cnqr-slider');
    var track = slider.querySelector('.cnqr-slider__track');
    var prev = document.querySelector('[data-cnqr-prev="' + key + '"]');
    var next = document.querySelector('[data-cnqr-next="' + key + '"]');
    function step() {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 14 : 300;
    }
    if (prev) prev.addEventListener('click', function() {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function() {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cnqr-product"]) return;
  try {
    
  (function () {
    function getMain() { return document.getElementById('cnqr-pdp-main'); }

    // ── Preload full-size images so swaps are instant (no lag that looks like "no change") ──
    (function preload() {
      var urls = [];
      document.querySelectorAll('[data-cnqr-thumb]').forEach(function (t) {
        var u = t.getAttribute('data-cnqr-thumb');
        if (u) urls.push(u);
      });
      var mapEl = document.querySelector('[data-cnqr-color-images]');
      if (mapEl) {
        (mapEl.getAttribute('data-cnqr-color-images') || '').split('|||').forEach(function (pair) {
          var kv = pair.split('::');
          if (kv[1]) urls.push(kv[1]);
        });
      }
      urls.forEach(function (u) { var im = new Image(); im.src = u; });
    })();

    // ── Delegated click handling — survives late DOM / re-renders, never misses a click ──
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      // Thumbnail → swap main image
      var thumb = e.target.closest('[data-cnqr-thumb]');
      if (thumb) {
        var main = getMain();
        document.querySelectorAll('[data-cnqr-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.getAttribute('data-cnqr-thumb');
        return;
      }

      // Option / colour swatch → select variant
      var optBtn = e.target.closest('[data-cnqr-opt-val]');
      if (optBtn && !optBtn.disabled) {
        var group = optBtn.closest('[data-cnqr-opt-group]');
        if (group) {
          group.querySelectorAll('[data-cnqr-opt-val]').forEach(function (x) { x.classList.remove('is-active'); });
          optBtn.classList.add('is-active');
          var disp = group.querySelector('[data-cnqr-opt-value]');
          if (disp) disp.textContent = optBtn.getAttribute('data-cnqr-opt-val');
          updateVariant();
        }
        return;
      }

      // Qty steppers
      var step = e.target.closest('[data-cnqr-qty-step]');
      if (step) {
        var input = step.parentElement.querySelector('input[name="quantity"]');
        if (input) {
          var v = parseInt(input.value, 10) || 1;
          v = Math.max(1, Math.min(99, v + parseInt(step.getAttribute('data-cnqr-qty-step'), 10)));
          input.value = v;
        }
        return;
      }
    });

    function updateVariant() {
      var form = document.querySelector('[data-cnqr-pdp-form]');
      if (!form) return;
      var selected = [];
      form.querySelectorAll('[data-cnqr-opt-group]').forEach(function (g) {
        var a = g.querySelector('[data-cnqr-opt-val].is-active');
        selected.push(a ? a.getAttribute('data-cnqr-opt-val') : null);
      });
      var data = form.querySelector('[data-cnqr-variants]');
      if (data) {
        try {
          var variants = JSON.parse(data.textContent);
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === selected[i]; });
          });
          if (match) {
            var idEl = form.querySelector('[data-cnqr-variant-id]');
            var atc = form.querySelector('.cnqr-pdp__atc');
            var priceEl = document.querySelector('.cnqr-pdp__price-now');
            if (idEl) idEl.value = match.id;
            if (atc) {
              atc.disabled = !match.available;
              atc.textContent = match.available ? 'Add To Cart' : 'Sold Out';
            }
            if (priceEl) priceEl.textContent = formatMoney(match.price);
          }
        } catch (e) {}
      }

      // Swap main image based on the selected colour (works even if that size is sold out)
      var main = getMain();
      var colorMapEl = document.querySelector('[data-cnqr-color-images]');
      var activeColor = document.querySelector('.cnqr-pdp__opt-group--color [data-cnqr-opt-val].is-active');
      if (colorMapEl && activeColor && main) {
        var wantColor = (activeColor.getAttribute('data-cnqr-opt-val') || '').toLowerCase();
        var pairs = (colorMapEl.getAttribute('data-cnqr-color-images') || '').split('|||');
        for (var i = 0; i < pairs.length; i++) {
          var kv = pairs[i].split('::');
          if (kv[0] === wantColor && kv[1]) {
            main.src = kv[1];
            document.querySelectorAll('[data-cnqr-thumb]').forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-cnqr-thumb') === kv[1]);
            });
            break;
          }
        }
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // ── ATC submit (delegated) ──
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-cnqr-pdp-form]') : null;
      if (!form) return;
      e.preventDefault();
      var atc = form.querySelector('.cnqr-pdp__atc');
      var idEl = form.querySelector('[data-cnqr-variant-id]');
      var qtyEl = form.querySelector('input[name="quantity"]');
      if (!idEl || !qtyEl) return;
      var orig = atc.textContent;
      atc.disabled = true; atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: parseInt(qtyEl.value, 10) || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (er) { throw er; });
        return r.json();
      }).then(function () {
        atc.textContent = 'Added!';
        if (window.CNQR) {
          window.CNQR.refreshCartCount();
          window.CNQR.toast('Added to cart');
        }
        setTimeout(function () { atc.disabled = false; atc.textContent = orig; }, 1800);
      }).catch(function (err) {
        atc.disabled = false; atc.textContent = orig;
        if (window.CNQR) window.CNQR.toast((err && err.description) || 'Could not add item', 'err');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
